import { LOGIN_USER, REMOVE_TOKEN, REMOVE_USERS, SET_TOKEN ,SET_ORGANIZATION} from "../types";

const initialState = {
    user: null,
    organization: null, 
    isAuthenticated: false,
    token: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_USER: {
            return {
                ...state,
                user: action.user,
                isAuthenticated: true,
            };
        }
        case SET_ORGANIZATION: {
            return {
                ...state,
                organization: action.payload, 
            };
        }
        case REMOVE_USERS: {
            return {
                ...state,
                user: null,
                organization: null,
                isAuthenticated: false,
            };
        }
        case REMOVE_TOKEN: {
            return {
                ...state,
                token: null,
            };
        }
        case SET_TOKEN: {
            return {
                ...state,
                token: action.payload,
            };
        }
       
        default: {
            return state;
        }
    }
};

export default reducer;
